<template>
    <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParams" ref="form" :inline="true" size="mini">
        <el-form-item label="设备名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParams.deviceName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParams.deviceNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户昵称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParams.nickname"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户电话">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParams.phone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="开门时间">
            <el-date-picker
            @change="dateChange"
            v-model="selectDate"
            type="datetimerange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
      <el-table
      :data="list"
      stripe
      style="width: 100%">
      <el-table-column
        prop="date"
        label="设备名称">
        <template slot-scope="scope">
           {{ scope.row.deviceName}}
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="设备号">
        <template slot-scope="scope">
           {{ scope.row.deviceNo}}
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="用户昵称">
        <template slot-scope="scope">
           {{ scope.row.nickname}}
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="用户电话">
        <template slot-scope="scope">
           {{ scope.row.phone}}
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="开门时间">
        <template slot-scope="scope">
           {{ scope.row.openDoorTime}}
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageNo"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    </div>
  </template>
  
  <script>
  import {getWlOpenDoorInfo} from '@/api/traceabilityCode';
  export default {
    data() {
      return {
       list:[],
       total: 0,
       pageSizes: [15, 20, 30, 40, 100, 200],
       pageSize: 15,
       pageNo: 1,
       selectDate: undefined,
       queryParams: {
        deviceName: undefined,
        deviceNo: undefined,
        nickname: undefined,
        openDoorTimeStart: undefined,
        openDoorTimeEnd: undefined
       },
      };
    },
    watch: {},
    computed: {},
    mounted() {
        this.getDataList();
    },
    methods: {
    dateChange (date) {
      if (date) {
        this.queryParams.openDoorTimeStart = date[0];
        this.queryParams.openDoorTimeEnd = date[1];
      } else {
        this.queryParams.openDoorTimeStart = ''
        this.queryParams.openDoorTimeEnd = ''
      }
    },
    searchReset() {
        this.queryParams.deviceName= undefined;
        this.queryParams.deviceNo=undefined;
        this.queryParams.nickname= undefined;
        this.queryParams.openDoorTimeStart = undefined
        this.queryParams.openDoorTimeEnd = undefined;
    },
    getDataList() {
        const params = {
        pageNo:this.pageNo,
        pageSize: this.pageSize,
        ...this.queryParams
        }
        getWlOpenDoorInfo(params).then((res)=>{
            this.list = res.data.records;
            this.total = res.data.total
        })
    },
     handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getDataList();
    },
    searchQuery () {
      this.getDataList();
    }
    },
  };
  </script>
  <style lang="scss" scoped>
  .wrapper {
    padding: 20px;
    .el-pagination {
        text-align: right;
    }
    .el-table .el-table__cell {
        text-align: center !important;
    }
  }
  </style>
  